import dayjs from "dayjs";

import { Button, ButtonType } from "@/components/common/button";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { HelpYouLoseSvg } from "@/pages/quiz/base/questions/banners/common/helpYouLoseSvg";
import { HelpYouLoseMicrodoseSvg } from "@/pages/quiz/base/questions/banners/common/helpYouLoseMicrodoseSvg";
import { WeightLossStats } from "@/pages/quiz/base/questions/banners/common/weightLossStats";
import { useQuizContext } from "@/pages/quiz/context";
import { useIsABTest } from "@/hooks/useIsABTest";
import { useIsMicrodose } from "@/hooks/useIsMicrodose";
import { MICRODOSE_WEIGHT_LOSS_AFTER_THREE_MONTHS } from "@/constants/bmi";

const WeCanHelpYouLose = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  const { answers } = useQuizContext();
  const { isABTest_6_Header } = useIsABTest();

  const { isMicrodose } = useIsMicrodose();

  // const fullNameQuestion = Object.values(answers).find(
  //   (answer) => answer.blockName === "contact-full-name"
  // )?.value as {
  //   firstName: string;
  //   lastName: string;
  // };

  const weightQuestion = Object.values(answers).find(
    (answer) =>
      answer.blockName === "height-weight-input-fields" ||
      answer.blockName === "height-weight-input-fields-with-bmi"
  )?.value as {
    weight: string;
  };

  const startWeight = Number(weightQuestion?.weight || 0);

  const weigthAfterThreeMonths = isMicrodose
    ? MICRODOSE_WEIGHT_LOSS_AFTER_THREE_MONTHS
    : Math.round(startWeight * 0.18);

  return (
    <>
      <div className="!font-normal section-title">
        We can help you lose up to <b>{weigthAfterThreeMonths} pounds </b>by{" "}
        <b>{dayjs(new Date()).add(3, "month").format("MM/DD/YYYY")}!</b>
      </div>
      <div className="mt-4 flex justify-center">
        {isMicrodose ? (
          <HelpYouLoseMicrodoseSvg
            weight={{
              first:
                startWeight - MICRODOSE_WEIGHT_LOSS_AFTER_THREE_MONTHS * 0.35,
              second:
                startWeight - MICRODOSE_WEIGHT_LOSS_AFTER_THREE_MONTHS * 0.7,
              third: startWeight - MICRODOSE_WEIGHT_LOSS_AFTER_THREE_MONTHS,
            }}
          />
        ) : (
          <HelpYouLoseSvg
            weight={{
              first: startWeight * 0.95,
              second: startWeight * 0.9,
              third: startWeight * 0.86,
              fourth: startWeight * 0.82,
              fifth: startWeight * 0.8,
            }}
          />
        )}
      </div>
      <div className="flex flex-col">
        <Button
          type={ButtonType.CONTINUE}
          onClick={() => setQuestionAnswer(true)}
          className={`${isABTest_6_Header ? "order-1" : "order-2"}`}
        />
        {isABTest_6_Header && (
          <div
            className={`flex flex-col mt-4 ${
              isABTest_6_Header ? "order-2" : "order-1"
            }`}
          >
            <WeightLossStats />
            <p className="mt-4 text-center text-[#6E6E6E] text-xs">
              Based on self-reported data from 160 SkinnyRx members while on
              GLP-1 injections, while combined with diet and exercise.
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export { WeCanHelpYouLose };
